<template>
    <div id="ContainerPatientChartReview">
        <ChartReviewBase v-bind:Origin="'Patient'" />
    </div>
</template>

<script>
import ChartReviewBase from "@/components/pages/chartreview/ChartReview";
import { EventBus } from '@/event-bus.js';

export default {
    name: 'PatientChartReview',
    mixins: [ChartReviewBase],
    created(){
        EventBus.$on("ShowWeel", function (isShow) { 
            isShow ? this.$emit('load', true) : this.$emit('load', false);     
        }.bind(this));
    },
};
</script>